import React from 'react';
import { api } from '../utils/apiClient';

const CandidateTable = ({ candidates, onCandidateClick }) => {

  // Downloads go through the API client so they carry the sign-in token. The
  // address carries the report's id (excel_file); excel_name is the file's name.
  const handleDownload = async (candidate) => {
    try {
      const response = await api.downloadFile(candidate.excel_file);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', candidate.excel_name || 'step_determination.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download error:', error);
      alert('Error downloading file');
    }
  };

  const handleDownloadAll = async () => {
    try {
      const response = await api.downloadAll();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'all_step_determinations.zip');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download all error:', error);
      alert('Error downloading files. Please try again.');
    }
  };

  const formatExperience = (experience) => {
    if (typeof experience === 'number') return `${experience.toFixed(1)} years`;
    if (typeof experience === 'string' && experience !== 'N/A') return experience;
    return 'N/A';
  };

  const qualChip = (isQualified, status) => status === 'NOT ASSESSED'
    ? <span className="chip warn">NOT ASSESSED</span>
    : isQualified
      ? <span className="chip ok"><i className="fas fa-check"></i> {status || 'QUALIFIED'}</span>
      : <span className="chip no"><i className="fas fa-xmark"></i> {status || 'NOT QUALIFIED'}</span>;

  const stepChip = (step) => (step && step !== 'N/A' && step !== 'Error')
    ? <span className="chip step"><i className="fas fa-stairs"></i> {step}</span>
    : <span className="chip neutral">N/A</span>;

  return (
    <section className="block">
      <div className="tablewrap">
        <div className="table-head">
          <div className="th-title">
            <i className="fas fa-users"></i> Candidate qualification results
            <span className="count">{candidates.length}</span>
          </div>
          <button className="btn btn-light btn-sm" onClick={handleDownloadAll}>
            <i className="fas fa-file-excel"></i> Download all Excel files
          </button>
        </div>
        <div className="table-scroll">
          <table className="who-table">
            <thead>
              <tr>
                <th>Name</th><th>Nationality</th><th>Current position</th><th>Total exp</th>
                <th>Relevant exp</th><th>Qualification</th><th>Step</th><th>Education</th><th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {candidates.map((candidate) => (
                <tr key={candidate.id} onClick={() => onCandidateClick(candidate)}>
                  <td>
                    <div className="cand-name"><i className="fas fa-user" style={{ color: 'var(--brand)' }}></i> {candidate.name}</div>
                    <div className="cand-mail">{candidate.email}</div>
                  </td>
                  <td>{candidate.nationality}</td>
                  <td><div title={candidate.current_position} style={{ maxWidth: '130px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{candidate.current_position}</div></td>
                  <td><span className="exp-info">{formatExperience(candidate.total_experience)}</span></td>
                  <td><span className="exp-rel">{formatExperience(candidate.relevant_experience)}</span></td>
                  <td>{qualChip(candidate.is_qualified, candidate.qualification_status)}</td>
                  <td>{stepChip(candidate.step_determination)}</td>
                  <td><div title={candidate.highest_education} style={{ maxWidth: '110px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{candidate.highest_education}</div></td>
                  <td>
                    <div className="row-actions">
                      <span className="icon-btn" title="View details" onClick={(e) => { e.stopPropagation(); onCandidateClick(candidate); }}>
                        <i className="fas fa-eye"></i>
                      </span>
                      <span className="icon-btn green" title="Download Excel" onClick={(e) => { e.stopPropagation(); handleDownload(candidate); }}>
                        <i className="fas fa-download"></i>
                      </span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="table-foot"><i className="fas fa-circle-info"></i> Click a candidate row to view the detailed step-determination analysis.</div>
      </div>
    </section>
  );
};

export default CandidateTable;
